export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    ADMIN: '/admin',
    TOURNAMENT: '/tournament',
    PRIVACY: '/privacy',
    ADDEVENT: '/addevent'
}

